export const AppConstant = {
    BASE_URL: "https://oc4cc5799d.execute-api.ap-southeast-2.amazonaws.com/prod/api",
    IMAGE_BASE_URL: "https://d1rm4dg6zsnjq3.cloudfront.net/",

    //  BASE_URL: "http://localhost:5005/api",
    // IMAGE_BASE_URL: "http://localhost:5005/",

    authToken: "authToken",
    isAdmin: "isAdmin",
    isPartner: "isPartner",
    adminId: "adminId",
    partnerId: "partnerId",
    createdById: "createdById",
    isAuthenticated: "isAuthenticated",
    CART_KEY: "cart",
    Admin: "admin",
    selectedPrice: "selectedPrice",
    selectedPriceType: "selectedPriceType",
    pickupPrice: "Pickup Price",
    mobileFittingPrice: "Mobile Fitting",
    storePrice: "Store Fitting",
    deliveryPrice: "Delivery Price",
    pickUpPrice: "Pick up price",
    selectedCityData: "selectedCityData",
    selectedPartnerAdmin: "selectedPartnerAdmin",
    extraPrice: 60,
}